/** Tickets created from a churn signal store the signal UUID in `Metadata.signalId` (API). */
export function getSignalIdFromTicketMetadata(metadata?: Record<string, unknown> | null): string | null {
  if (!metadata || typeof metadata !== 'object') return null;
  const m = metadata as Record<string, unknown>;
  const raw = m.signalId ?? m.SignalId;
  if (raw == null) return null;
  const s = String(raw).trim();
  return s || null;
}
